import { FeatureContext } from "@/modules/common/components/layout/side-menu/old-navbar/feature.context";
import { EnvironmentVariables } from "@/modules/common/types";
import { useContext, useEffect } from "react";

export const FeatureProvider = () => {
  const {
    setConfigs,
  }: {
    setConfigs: any;
  } = useContext(FeatureContext);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    //let s3BucketURL = await getFeaturesConfigURL()
    //sending a request to the AWS S3 bucket requesting the config file
    //make sure that the file is upload in the following template
    //{COMPANYNAME-configs.json}
    const s3BucketURL = `${EnvironmentVariables.S3BUCKET_URL}${EnvironmentVariables.COMPANY_NAME}-configs.json`;
    const s3Response = await fetch(s3BucketURL);
    try {
      const s3ResponseJson = await s3Response.json();
      setConfigs(s3ResponseJson);
    } catch (e) {
      setConfigs({});
    }
  };

  return <></>;
};
